export default "__VITE_ASSET__DiBmDT32__"